// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { PatientData, ProvenanceData } from './patientsSlice'
import { Practitioner, Provenance } from 'fhir/r4'
import { makeName } from '../lms/utils'
import { LocationData } from '../location/locationSlice'
import { getTotalAge } from '../../utils/dateUtils'
import { startSxpProxy } from '../../utils/api'
import { FormattedPatient } from './Patients'
import { home, mobile } from '../OPDScreen/constant'

export const getProvenanceData = (
  entries: any
): Record<string, ProvenanceData> => {
  const practitioners: Practitioner[] = entries.filter(
    (e: Practitioner) => e.resourceType === 'Practitioner'
  )
  const practitionerObj: Record<string, string> = practitioners.reduce(
    (prev: Record<string, string>, curr) => {
      if (curr.id) {
        prev[curr.id] = makeName(curr.name)
      }
      return prev
    },
    {}
  )
  const provenances: Provenance[] = entries.filter(
    (e: Provenance) => e.resourceType === 'Provenance'
  )
  provenances.sort((a, b) => {
    if (!a.recorded) {
      return -1
    }
    if (!b.recorded) {
      return 1
    }
    return a.recorded < b.recorded ? -1 : 1
  })
  return provenances.reduce((prev: Record<string, ProvenanceData>, curr) => {
    const pId = curr.target?.[0]?.reference?.split('/')?.[1] ?? ''
    if (pId) {
      let existing = prev[pId] ?? {}
      const practitionerId =
        curr.agent?.[0]?.who?.reference?.split('/')?.[1] ?? ''
      const activity = curr.activity?.coding?.[0]?.code
      if (activity === 'CREATE') {
        existing = {
          ...existing,
          createdOn: curr.recorded,
          createdBy: practitionerObj[practitionerId],
        }
      }
      if (activity === 'UPDATE') {
        existing = {
          ...existing,
          updatedOn: curr.recorded,
          updatedBy: practitionerObj[practitionerId],
        }
      }
      prev[pId] = existing
    }
    return prev
  }, {})
}

// export const LocationByPrefix = (id: string): string => {
//   const prefix = id?.slice(0, 6)
//   switch (prefix) {
//     case 'MUH001':
//       return 'Amalapuram'
//     case 'MUC001':
//       return 'Razole'
//     case 'MUC002':
//       return 'Tatipaka'
//     case 'MUC003':
//       return 'Rajahmundry'
//     case 'MUA001':
//       return 'Malkipuram'
//     case 'MUC006':
//       return 'Bhimavaram'
//     case 'MUC005':
//       return 'Kothapeta'
//     case 'MUC004':
//       return 'Mummidivaram'
//     case 'MUH777':
//       return 'Mental Health App'
//     case 'MUH888':
//       return 'Dengue App'
//     case 'KIMH01':
//       return 'KIMS Amalapuram'
//     default:
//       return 'Unknown'
//   }
// }
export const openUrlFromApi = async (
  projectId: any,
  apiLink: any,
  payload: any
) => {
  try {
    const data = await startSxpProxy(projectId, apiLink, payload)
    const url = data?.data?.auth_link
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else {
      console.error('No auth_link found in response data')
    }
  } catch (err) {
    console.error(err, 'Error opening URL')
  }
}

export const getLocationAddress = (uhid: string, locations: LocationData[]) => {
  if (uhid) {
    const prefix = uhid?.slice(0, 6)
    return locations?.find((l) =>
      l?.resource?.identifier?.some((lri) => lri?.value === prefix)
    )?.resource
  }
}
export const getLocationAddressByName = (
  uhid: string,
  locations: LocationData[]
) => {
  return locations?.find((l) => l?.resource?.name === uhid)?.resource
}
export const capitalizeFirstLetter = (word?: string) => {
  if (!word) return '-'

  return word.charAt(0).toUpperCase() + word.slice(1)
}
export const formatPatient = (e: any) => {
  const name = makeName(e?.name)
  const age = getTotalAge(e?.birthDate)
  const gender = capitalizeFirstLetter(e?.gender)
  const tel1 = e?.telecom?.find((prt: { use: string }) => prt.use === 'mobile')
  const tel2 = e?.telecom?.find((prt: { use: string }) => prt.use === 'home')
  return {
    id: e?.id,
    name: name,
    age: age,
    gender: gender,
    mobile: tel1?.value ?? tel2?.value ?? '',
  }
}
export const formmattedPatientList = (patients: any[]) => {
  const formatted: FormattedPatient[] = patients?.map((p: PatientData) => {
    const thop = p?.resource?.identifier?.[0]
    const bahmni = p?.resource?.identifier?.[2]
    const created = p?.resource?.identifier?.[3]
    const regType = p?.resource?.identifier?.[3]
    const invoice = p?.resource?.identifier?.[5]
    const name = makeName(p?.resource?.name)
    const age = getTotalAge(p?.resource?.birthDate)
    const gender = capitalizeFirstLetter(p?.resource?.gender)
    const tel1 = p?.resource?.telecom?.find((prt) => prt?.use === mobile)
    const tel2 = p?.resource?.telecom?.find((prt) => prt?.use === home)
    return {
      id: bahmni?.value ?? thop?.value ?? p?.resource?.id ?? '',
      name: name?.trim() ?? '',
      gender: gender,
      age: age,
      fhirId: p.resource?.id ?? '',
      thopId: thop?.value ?? '',
      invoiceId: invoice?.value ?? '',
      registeredOn: created?.period?.start ?? '',
      registrationType: regType?.value ?? '',
      mobile: tel1?.value ?? tel2?.value ?? '',
    }
  })
  return formatted
}
